import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("jnexpertise@gmail.com");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Connexion impossible");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 relative grid-noise bg-[#1E2066] border-r border-[#15174B]">
        <div className="absolute inset-0 flex flex-col justify-between p-12">
          <div className="flex items-center gap-4">
            <img
              src="https://customer-assets-wrfwihn1.emergentagent.net/job_time-track-expert/artifacts/0nksxe8x_JN%20EXPERTISE_logo_original.png"
              alt="JN Expertise"
              className="h-14 w-14 rounded-lg bg-white object-contain p-1"
              data-testid="login-logo"
            />
            <div className="font-serif-display text-3xl text-white">JN Expertise</div>
          </div>
          <div className="max-w-md">
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#C5B9E4] mb-3">Suite intégrée cabinet</div>
            <h2 className="font-serif-display text-4xl leading-tight text-white">
              Expertise comptable, commissariat aux comptes et audit — France & OHADA.
            </h2>
            <p className="mt-6 text-sm text-[#C5B9E4]">
              Suivi du temps, lettres de mission, programmes de travail et LCB-FT — assistés par IA.
            </p>
          </div>
          <div className="text-xs text-[#C5B9E4]">Paris • Yaoundé</div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={onSubmit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-2">Connexion</div>
            <h1 className="font-serif-display text-4xl">Espace collaborateurs</h1>
          </div>
          <div className="space-y-3">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
            </div>
            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#2E3192] hover:bg-[#1E2066]" data-testid="login-submit">
            {loading ? "Connexion…" : "Se connecter"}
          </Button>
          <p className="text-xs text-zinc-500 text-center">
            Accès réservé aux collaborateurs du cabinet.
          </p>
        </form>
      </div>
    </div>
  );
}
